/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { ValidatedInput } from '@finbeat/react-toolkit';
import { BODatePicker } from 'base-components/BODatePicker/BODatePicker';
import { SelectOption } from 'models/api/prop';
import { TariffProcedureParamAdd } from 'models/api/tariffProcedureParam';
import { FieldPath, useFormContext } from 'react-hook-form';
import 'scss/Main.scss';

type ProcedureParamInputProps = {
    type: string;
    selectOptions: SelectOption[];
    label: string;
    name: FieldPath<TariffProcedureParamAdd>;
    id?: string;
    disabled: boolean;
};

const ProcedureParamInput = ({
    id,
    type,
    label,
    selectOptions,
    disabled,
    name,
}: ProcedureParamInputProps) => {
    const { watch, setValue } = useFormContext<TariffProcedureParamAdd>();
    const value = watch(name);
    switch (type) {
        case 'bool':
            return (
                <ValidatedInput
                    id={id}
                    type="checkbox"
                    label={label}
                    name={name}
                    disabled={disabled}
                />
            );
        case 'datetime':
            return (
                <BODatePicker
                    value={value as string}
                    onChange={(val) => {
                        setValue(name, val);
                    }}
                    inputProps={{ label: label }}
                    disabled={disabled}
                />
            );
        case 'number':
            return (
                <ValidatedInput
                    id={id}
                    type="number"
                    name={name}
                    label={label}
                    disabled={disabled}
                />
            );
        default:
            if (selectOptions && selectOptions.length) {
                return (
                    <ValidatedInput
                        id={id}
                        type="select"
                        label={label}
                        options={selectOptions.map((i, index) => (
                            <option value={i.value} key={index}>
                                {i.text}
                            </option>
                        ))}
                        name={name}
                        disabled={disabled}
                    />
                );
            } else {
                return <ValidatedInput id={id} name={name} label={label} disabled={disabled} />;
            }
    }
};

export default ProcedureParamInput;
